<template>
  <div>
    <layout doc_id="requirements" :req_id="id">
      <template v-slot:body>
        <component
          :is="get_componet_id"
          :key="id">
        </component>
      </template>
    </layout>

    <div class="report" v-if="!isMobile" @click="generateReport">
      <div class="report__text">Скачать в PDF</div>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'report__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8 11.575c-.133 0-.258-.021-.375-.063A.871.871 0 017.3 11.3L3.7 7.7a.948.948 0 01-.275-.7c0-.283.092-.517.275-.7.183-.183.42-.28.712-.288.292-.008.53.08.713.263L7 8.15V1c0-.283.096-.521.288-.713A.967.967 0 018 0a.97.97 0 01.713.287A.97.97 0 019 1v7.15l1.875-1.875c.183-.183.421-.271.713-.263.291.009.529.105.712.288a.948.948 0 01.275.7.948.948 0 01-.275.7l-3.6 3.6c-.1.1-.208.17-.325.212a1.099 1.099 0 01-.375.063zM2 16c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 010 14v-2a.97.97 0 01.287-.713A.97.97 0 011 11a.97.97 0 01.713.287A.97.97 0 012 12v2h12v-2c0-.283.096-.521.288-.713A.967.967 0 0115 11c.283 0 .52.096.712.287.192.192.288.43.288.713v2c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0114 16H2z"/></svg>
    </div>
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :manual-pagination="true"
      filename="buzzoola_format"
      :pdf-quality="2"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      :html-to-pdf-options="{
        enableLinks: true,
      }"
    >
      <section slot="pdf-content">
        <div class="vue-html2pdf-wrap">
          <component
            :is="get_componet_id"
            :key="id">
          </component>
        </div>
      </section>
    </vue-html2pdf>

  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';
import VueHtml2pdf from 'vue-html2pdf';
import MENU_DATA from '@/constants.js';
import layout from '@/components/documentation/layout.vue';

export default {
  name: 'TechnicalRequirements',
  components: {
    layout,
    VueHtml2pdf,
  },
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return { isMobile };
  },
  computed: {
    get_componet_id() {
      let componentID = MENU_DATA.REQUIREMENTS[0].component_id;
      if (this.id) {
        const found = MENU_DATA.REQUIREMENTS.find((el) => el.url_id === this.id);
        if (found) {
          componentID = found.component_id;
        }
      }
      return componentID;
    },
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>

<style scoped lang='stylus'>
@import '../styles/main.styl'

.report
  position fixed
  top 20px
  left 210px
  z-index 14
  padding 12px
  cursor pointer
  display flex
  align-items center
  border-radius 8px
  &:hover
    background-color $orange
  +max-w-1000()
    top 4px
    left 180px
  &__text
    fontSize(15, 15)
    color $orange
    margin-right 5px
    ^[0]:hover &
      color $white
  &__icon
    width 20px
    height 20px
    fill $orange
    ^[0]:hover &
      fill $white

</style>
